<template>
    <div>
        <div class="login-header">
            <div><img class="medium-logo" src="../assets/DineSafeSquare.png"/></div>
            <div class="title dinesafe-purple">DineSafeVT</div>
            <div class=" dinesafe-label">New Password</div>
        </div>
        <div v-if="btnLoginVisible" class='back-button'>
            <DxButton 
                icon="user"
                ref="btnBackRef" 
                type="normal"
                text="Log In"
                styling-mode="text" 
                @click="btnBackToLogin"               
            />
        </div>  

        <!--<div v-if="newPasswordLabelVisible" class='dx-field confirm-email'>New Password</div>-->
        <div v-if="passwordSavedVisible" class='dx-field center'>Your password has been saved</div>

        <div class='create-account-input'>            
            <DxTextBox
                name="txtPassword"
                placeholder="Password"  
                :show-clear-button="true"
                mode="password"
                stylingMode="underlined"
                :value.sync="password"
                :visible.sync="txtPasswordVisible"
            >       
                <DxValidator>
                    <DxRequiredRule message="Password is required" />
                    <DxPatternRule
                        :pattern="passwordPattern"
                        :message="this.$store.state.globals.passwordMessage"
                    />
                </DxValidator>
            </DxTextBox>        
        </div>
        <div class='create-account-input'>            
            <DxTextBox
                name="txtConfirmPassword"
                placeholder="Confirm Password"
                :show-clear-button="true"
                mode="password"
                :value.sync="confirmPassword"
                :visible.sync="txtConfirmPasswordVisible"
            >       
                <DxValidator>
                    <DxRequiredRule message="Confirm your password" />
                    <DxCustomRule
                        :validation-callback="comparePasswords"
                        type="custom"
                        message="Passwords do not match"
                    />
                </DxValidator>
            </DxTextBox>
        </div>  

        <div v-if='btnSavePasswordVisible' class='center'>
            <DxButton 
                ref="btnSavePasswordRef" 
                type="default"
                text="Save Password"
                styling-mode="contained" 
                width="180"
                @click="btnSavePassword"
            />
        </div>
        
    </div>
</template>
 
<script>
    import DxTextBox from "devextreme-vue/text-box";
    import {DxButton} from 'devextreme-vue';
    import DxValidationGroup from "devextreme-vue/validation-group";
    import DxValidator, { DxRequiredRule, DxCustomRule, DxPatternRule } from "devextreme-vue/validator";
    import DxValidationSummary from 'devextreme-vue/validation-summary';
    import notify from 'devextreme/ui/notify';

    export default {
        components: {
            DxTextBox,
            DxButton,
            DxValidationGroup,
            DxValidator, DxRequiredRule, DxCustomRule, DxPatternRule,
            DxValidationSummary,
            notify,
        },
        data() {
            return {
                newPasswordLabelVisible: true,
                resetGuid: this.$route.params.resetGuid,
                password: null,
                confirmPassword: null,
                btnSavePasswordVisible: true,
                btnLoginVisible: false,
                passwordSavedVisible: false,
                txtPasswordVisible: true,
                txtConfirmPasswordVisible: true,
                passwordPattern: /((?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,20})/,
                /*
                    (			# Start of group
                    (?=.*\d)		#   must contains one digit from 0-9
                    (?=.*[a-z])		#   must contains one lowercase characters
                    (?=.*[A-Z])		#   must contains one uppercase characters
                    (?=.*[@#$%])		#   must contains one special symbols in the list "@#$%"
                                .		#     match anything with previous condition checking
                                    {6,20}	#        length at least 6 characters and maximum of 20
                    )			# End of group
                */
            }
        },
        methods:{
            /*
                Check if the passwords match
            */
            comparePasswords(e) {
                console.log("comparePasswords");

                //Check if the value for the Password matches the value for Confirm Password
                return this.password == this.confirmPassword;
                //return true;
            },
            btnSavePassword(data, actions) {
                console.log('btnSavePassword');

               //Validate the user inputs.
                if (data.validationGroup.validate().isValid) 
                {
                    //Hit the web service / run the stored proc
                    this.$http.post(this.$store.state.appSettings.webServiceUrl + 'UpdatePassword',
                    {
                        ResetGuid: this.resetGuid,
                        Password: this.password,
                    }
                    ).then(function(data){         
                        if(data.body != null && data.body != ''){
                            var responseData = JSON.parse(data.body); 

                            //Show a message if the e-mail is not present in our system.  The stored proc already lets me know if that is the case
                            if(responseData[0].Message == "ResetGuid not found"  
                                || responseData[0].Message == "ResetGuid is expired"
                                || responseData[0].Message == "ResetGuid is already used")
                            {
                                notify(
                                {
                                    message: "Password could not be updated", 
                                    type:"error", 
                                    width:100, 
                                    displayTime: 2000,
                                    position: {
                                    my: 'center center',
                                    at: 'center center',
                                    }
                                });
                            }
                            else if(responseData[0].Message = "Success")
                            {                                                       
                                this.btnLoginVisible = true;
                                this.passwordSavedVisible = true;
                                this.txtPasswordVisible = false;
                                this.txtConfirmPasswordVisible = false;
                                this.newPasswordLabelVisible = false;
                                this.btnSavePasswordVisible = false;
                            }
                        }
                        else{
                            //Unexpected error, an empty response was received from the web service method
                            notify(
                            {
                                message: "Password could not be updated", 
                                type:"error", 
                                width:100, 
                                displayTime: 2000,
                                position: {
                                my: 'center center',
                                at: 'center center',
                                }
                            });
                        }
                    });  
                }
            },
            btnBackToLogin(e){
                //Navigate to the Login page
                this.$router.push("/login-form");
            }
        }
    }
</script>

<style scoped>
    .center{
        display: flex; 
        justify-content: center;

        margin-top: 20px;
    }

    .confirm-email{
        padding-top: 20px;
    }
</style>